import { render, staticRenderFns } from "./DeactivateUser.vue?vue&type=template&id=46180696&scoped=true&"
import script from "./DeactivateUser.vue?vue&type=script&lang=js&"
export * from "./DeactivateUser.vue?vue&type=script&lang=js&"
import style0 from "./DeactivateUser.vue?vue&type=style&index=0&id=46180696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46180696",
  null
  
)

export default component.exports